import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';

import { UserRolesMappings } from '@app/models/user';
import * as PackagingActions from '@core/actions/packaging.actions';
import * as FileSaver from 'file-saver/FileSaver';


const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class PackagingService {
  constructor(private http: HttpClient, private store: Store<any>) {}

  getPackaging(id?, mode?) {
    if(id){
      return this.http.get<any>(`${API}packaging?PackagingId=${id}&Mode=${mode}`);
    }
    return this.http.get<any>(`${API}packaging/`);
  }

  getFollowListPackaging() {
    return this.http.get<any>(`${API}packaging/FollowList`);
  }

  createPackaging(data) {
    return this.http.post<any>(`${API}packaging/`, data);
  }

  duplicateWithCodes(packId, objPackaging){
    const data = {
      packId: packId,
      followId: objPackaging.selectedFollowId,
      managementId: objPackaging.selectedManagementId,
      secondFollowId: objPackaging.selectSecondFollowId
    }
    return this.http.post<any>(`${API}packaging/duplicate-with-codes`, data);
  }

  duplicatePackaging(id) {
    const data = {
      id: id
    }
    return this.http.post<any>(`${API}packaging/duplicate`, data);
  }

  updatePackagingFromFile(data){
    return this.http.post<any>(`${API}packaging/fromFile`, data);
  }

  getPackagingMilestones() {
    return this.http.get<any>(`${API}packaging/milestones/all`); 
  }

  updatePackaging(id, data, name?){
    // console.log("DATA ->", data)
    // console.log("NOMBRE PACK ->", name)
    const temp = {...data, namePackaging: name}
    return this.http.put<any>(`${API}packaging/${id}`, temp);
  }

  uploadImgs(packagingId, file, featured){
    const mimeType = file.type;
    const name = file.name;

    return this.http.post<string>(`${API}packaging/files`, {
      mimeType,
      name,
      featured,
      FileableType: 'PackagingFields',
      FileableId: packagingId
    });
  }

  deletePackaging(id){
    return this.http.delete<any>(`${API}packaging/${id}`);
  }

  downloadAllProviders(PackagingId){
    return this.http
    .get(`${API}packaging/downloadAllProviders/${PackagingId}`, {
      responseType: 'blob',
      observe: 'response'
    })
    .subscribe(
      response => {
        // const blob = response.body;
        // FileSaver.saveAs(blob, 'providers.zip');
        this.store.dispatch(new PackagingActions.PackagingExportMassivePending("Descargando..."));
      },
      err => {
        this.store.dispatch(new PackagingActions.ExportPackagingFail(err));
      }
    );
  }

  exportOrder(PackagingId){
    return this.http
    .get(`${API}packaging/file-order/${PackagingId}`, {
      responseType: 'blob',
      observe: 'response'
    })
    .subscribe(
      response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Orden - ${PackagingId}.xlsx`);
          this.store.dispatch(new PackagingActions.ExportPackOrderSuccess());
        },
        err => {
          this.store.dispatch(new PackagingActions.ExportPackagingFail(err));
        }
    );
  }

  exportPackagingMaster(){
    return this.http
    .get(`${API}packaging/master-packaging`, {
      responseType: 'blob',
      observe: 'response'
    })
    .subscribe(
      response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Maestra packaging.xlsx`);
          this.store.dispatch(new PackagingActions.DownloadPackagingMasterSuccess());
        },
        err => {
          this.store.dispatch(new PackagingActions.DownloadPackagingMasterFail(err));
        }
    );
  }

  exportPackagingMasterFields(){
    return this.http
    .get(`${API}packaging/master-packaging-fields`, {
      responseType: 'blob',
      observe: 'response'
    })
    .subscribe(
      response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Maestra Campos packaging.xlsx`);
          this.store.dispatch(new PackagingActions.DownloadPackagingMasterFieldsSuccess());
        },
        err => {
          this.store.dispatch(new PackagingActions.DownloadPackagingMasterFieldsFail(err));
        }
    );
  }
  
  finishExportMassiveProviders(data, followId){
    console.log("DATA ->", data)
    return this.http
      .get(data, {
        responseType: 'blob',
        observe: 'response'
      }).subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `${followId} Supplier.zip`);
          this.store.dispatch(new PackagingActions.PackagingExportMassiveFinish());
        },
        err => {
          this.store.dispatch(new PackagingActions.ExportPackagingFail(err));
        }
      )
  }

  finishExportPackaging(data, name){
    console.log("DATA ->", data)
    return this.http
      .get(data, {
        responseType: 'blob',
        observe: 'response'
      }).subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `${name}.xlsx`);
          this.store.dispatch(new PackagingActions.ExportPackagingSuccess());
        },
        err => {
          this.store.dispatch(new PackagingActions.ExportPackagingFail(err));
        }
      )
  }

  exportPackaging(id, role?, followId?, packagingId?, typePack?, providerName?, unitBusiness?, country?){
    console.log("ANTIGUO PACK", role)
    // let newRole = role === "designer" ? '' : role
    let newRole = role
    return this.http
    .get(`${API}packaging/export/${id}?role=${newRole}&followId=${followId}&packagingId=${packagingId}&typePack=${typePack}&unitBusiness=${unitBusiness}&country=${country}`, {
      responseType: 'blob',
      observe: 'response'
    })
    .subscribe(
      response => {
        console.log("newRole ->", newRole)
        if (role === "providerMode" || role === "poviderModeFinal"|| role === "providerDesigner") {
          const blob = response.body;
          if (providerName) {
            FileSaver.saveAs(blob, `${followId} Packaging - ${providerName} - ${followId}.xlsx`);
          } else {
            if (typePack && typePack === "complete" && role !== "designer") {
              FileSaver.saveAs(blob, `Packaging FINAL- ${followId}.xlsx`);
            } else if (role === "designer") {
              FileSaver.saveAs(blob, `Packaging diseñador - ${followId}.xlsx`);
            } else {
              if (unitBusiness && country) {
                FileSaver.saveAs(blob, `Packaging pais ${country} ${unitBusiness} - ${followId}.xlsx`);
              } else {
                FileSaver.saveAs(blob, `Packaging PM - ${followId}.xlsx`);
              }
            }
          }
          this.store.dispatch(new PackagingActions.ExportPackagingSuccess());
        } else {
          this.store.dispatch(new PackagingActions.ExportPackagingPending(""));
        }
      },
      err => {
        this.store.dispatch(new PackagingActions.ExportPackagingFail(err));
      }
    );
  }

  exportNewPackaging(id, role?, followId?, packagingId?, typePack?){
    console.log("NUEVO PACK")
    return this.http
    .get(`${API}packaging/new-export/${id}?role=${role}&followId=${followId}&packagingId=${packagingId}&typePack=${typePack}`, {
      responseType: 'blob',
      observe: 'response'
    })
    .subscribe(
      response => {
        const blob = response.body;
        let tempRole = UserRolesMappings[role] || ""
        if (!tempRole) {
          tempRole = "Comprador"
        }
        const nameFile = `Packaging - ${tempRole} - ${followId}`
        FileSaver.saveAs(blob, `${nameFile}.xlsx`);
        this.store.dispatch(new PackagingActions.ExportPackagingSuccess());
      },
      err => {
        this.store.dispatch(new PackagingActions.ExportPackagingFail(err));
      }
    );
  }

  getPackagingImportLink(file, packgingId?, typeMode?){
    const mimeType = file.type;
    const name = file.name;
    const PackagingId = packgingId

    return this.http.post<string>(`${API}packaging/files`, {
      mimeType,
      name,
      PackagingId,
      typeMode
    });
  }

  uploadFile(link, file) {
    return this.http.put<any>(`${link}`, file);
  }

  agrupatedPacks(data) {
    return this.http.post<any>(`${API}packaging/grouped`, data);
  }

  getPacksCountries(packId) {
    console.log("PACKAGING ID SERVICE ->", packId)
    return this.http.get(`${API}packaging/countries/${packId}`);
  }

  getPacksMaster() {
    // console.log("PACKAGING ID SERVICE ->", packId)
    return this.http.get(`${API}packaging/all-master-packaging/`);
  }

  notifyFileUpload(id, metadata?, typeFile?, order?) {
    const { processType } = metadata;

    console.log(id)
    console.log(processType)

    return this.http.put<File>(
      `${API}files/${id}?processType=${processType || null}`,
      {
        status: 1,
      }
    );
  }

  deleteImgPack(packId, data?){
    return this.http.put<any>(`${API}packaging/img/${packId}`, data);
  }

}
